import { render, staticRenderFns } from "./TileEventChannel.vue?vue&type=template&id=37f88f75&"
import script from "./TileEventChannel.vue?vue&type=script&lang=js&"
export * from "./TileEventChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports